<template>
  <div>
    <div class="row">
      <div class="col-5">
        <div class="card card-custom mb-5">
          <!--begin::Body-->
          <div class="card-body row align-items-center py-0 mt-8">
            <div class=" col-7 py-lg-5">
              <h4
                class="card-title font-weight-bolder text-dark-75 font-size-h5 mb-2 text-hover-primary"
              >
                {{ users.firstName }} {{ users.lastName }}
              </h4>
              <span class="font-weight-bold text-muted font-size-lg">{{
                users.email
              }}</span
              ><br />
              <span
                class="font-weight-bold label label-inline label-danger text-white mt-5 mr-2"
                v-if="users.points"
                >{{ users.points.total }} Points</span
              >
              <span
                class="font-weight-bold label label-inline label-warning"
                v-if="levelUserName"
                >{{ levelUserName }}</span
              >
              <!-- <FileUpload :user="users" type="users" /> -->
            </div>
            <div
              class="col-5 py-lg-5 align-self-start text-center "
              style="width:100%"
            >
              <AvatarCropper :user="users" type="users" />
            </div>
          </div>
          <!--end::Body-->
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card card-custom mb-5">
              <div class="card-body d-flex flex-column" v-if="levels">
                <div class="flex-grow-1">
                  <div class="text-dark-50 font-weight-bold">
                    Level {{ levelUser }}
                  </div>
                  <div class="font-weight-bolder font-size-h3">
                    {{ levelUserName }}
                  </div>
                </div>
                <!-- <div class="progress progress-xs">
                    <div class="progress-bar bg-primary" role="progressbar" style="width: 75%;" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="card card-custom" v-if="users.team">
          <div class="card-header">
            <div class="card-title row p-2">
              <div class="col-6">
                <h3 class="font-weight-bolder text-dark-75 font-size-h5">
                  {{ users.team.name }}
                </h3>
              </div>
              <div class="col-6 text-right">
                <img
                  src="/media/logos/logo-1.png"
                  class="align-self-center"
                  width="100%"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-7">
        <div class="card card-custom">
          <div class="card-body p-0">
            <div
              class="wizard wizard-2"
              id="kt_wizard_v2"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
              <div class="wizard-body py-8 px-8 py-lg-15 px-lg-9">
                <div class="row" v-if="users">
                  <div class="offset-xxl-1 col-xxl-10">
                    <b-form v-on:submit.prevent="onSubmit(users._id, $event)">
                      <div class="pb-5">
                        <h4 class="mb-10 font-weight-bold text-dark">
                          Edit your profile
                        </h4>
                        <div class="row">
                          <div class="col-xl-4">
                            <div class="form-group">
                              <label>First Name</label>
                              <input
                                v-model="users.firstName"
                                type="text"
                                class="form-control form-control-solid form-control-lg"
                                ref="firstName"
                                name="firstName"
                                placeholder="First Name"
                              />
                            </div>
                          </div>
                          <div class="col-xl-8">
                            <div class="form-group">
                              <label>Last Name</label>
                              <input
                                v-model="users.lastName"
                                type="text"
                                class="form-control form-control-solid form-control-lg"
                                ref="lastName"
                                name="lastName"
                                placeholder="Last Name"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-xl-6">
                            <div class="form-group">
                              <label>User Name</label>
                              <input
                                v-model="users.userName"
                                type="text"
                                class="form-control form-control-solid form-control-lg"
                                name="userName"
                                placeholder="User Name"
                              />
                            </div>
                          </div>
                          <div class="col-xl-6">
                            <div class="form-group">
                              <label>Gender</label>
                              <select
                                v-model="users.gender"
                                class="form-control form-control-solid form-control-lg"
                                name="gender"
                              >
                                <option value="null">Select gender</option>
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex justify-content-between border-top pt-10"
                      >
                        <input
                          type="submit"
                          class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                          value="SAVE"
                        />
                      </div>
                    </b-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import FileUpload from "@/view/layout/extras/fileUpload";
import AvatarCropper from "@/view/layout/extras/avatarCropper";
//import { ApiService } from "@/core/services/api.service";
import Swal from "sweetalert2";
import axios from "axios";

var id;
export default {
  name: "profile",
  components: {
    //FileUpload,
    AvatarCropper
  },

  data() {
    return {
      hover: false,
      levelUserName: "",
      levelUser: "",
      levels: {},
      users: {},
      toEdit: {}
    };
  },
  created() {
    id = this.$route.params.usersId;

    axios.get("users/" + id).then(response => {
      this.users = response.data;
      axios.get("levels/").then(response => {
        this.levels = response.data;
        for (let x = 0; x < this.levels.length; x++) {
          if (this.levels[x].points <= this.users.points.total) {
            this.levelUser = x;
            this.levelUserName = this.levels[x].name;
          }
        }
      });
      console.log("USER", this.users);
      console.log(this.users.points.total);
    });
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "profile" }]);
  },
  methods: {
    onSubmit(id, e) {
      e.preventDefault();
      axios.put("users/" + id, this.users).then(response => {
        if (response.status == 200) {
          Swal.fire({
            title: "Update profile",
            text: "",
            icon: "success"
          });
        }
        this.$store.dispatch("fetchMyUser");
      });
    }
  }
};
</script>
